import React from 'react';
import CopsPageContainer from '../components/CopsPageContainer';

const Home = () => {
  return <CopsPageContainer></CopsPageContainer>;
};

export default Home;
